import React from 'react'
import logo from '../assets/logo_mark.svg'

export default function Logo(){
  return (
    <div id="logo" className="text-center py-1" data-testid="logo">
      <img src={logo} alt="SME Connect" height={80} />
    </div>
  )
}